import { Meteor } from 'meteor/meteor';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { Mongo } from 'meteor/mongo';
import { Roles } from 'roles';

import { BaseSchema } from '../baseSchema';

export const Memos = new Mongo.Collection('memos');
export default Memos;

Memos.attachRoles('places');

Memos.label = "Mémos";

export const MemoSchema = new SimpleSchema([{
    content: {
        type: String,
        label: "Contenu",
        optional: true
    },
    date: {
    	type: Date,
      label: "Date",
    }
}, BaseSchema]);

Memos.attachSchema(MemoSchema);



/** WEBPACK FOOTER **
 ** ./src/universal/collections/memos/memos.js
 **/